export default () => {

    return {

        mounted() {
            let vids = document.querySelectorAll('.bg-video'), i;
            for (i = 0; i < vids.length; ++i) {
                vids[i].play();
            }
        }

    }

}